import {Button, Spinner} from 'react-bootstrap'
import {ReactNode} from 'react'
import styles from './ImpactButton.module.css'

interface ImpactButtonProps {
    children: ReactNode
    onClick?: () => void
    disabled?: boolean
    loading?: boolean
    fullWidth?: boolean
    className?: string
    type?: 'button' | 'submit'
}

const ImpactButton: React.FC<ImpactButtonProps> = ({
    children,
    onClick,
    disabled = false,
    loading = false,
    fullWidth = false,
    className = '',
    type = 'button'
}) => {
    const isDisabled = disabled || loading

    return (
        <Button
            type={type}
            className={`${styles.impactButton} ${fullWidth ? styles.fullWidth : ''} ${className}`}
            disabled={isDisabled}
            onClick={loading ? undefined : onClick}
        >
            {loading ? (
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
            ) : (
                children
            )}
        </Button>
    )
}

export default ImpactButton
